import React from 'react';
import { useApptekster } from '../../contexts/ApptekstContext';
import { AktivSakStatus, DineSkiltSakStatus, SakStatus } from '../../utils/api';
import { SVVTextLink } from '@komponentkassen/svv-link';

type HentSkiltStegProps = {
    sakStatus: SakStatus;
};

export const HentSkiltSteg: React.FC<HentSkiltStegProps> = ({ sakStatus }) => {
    const t = useApptekster();

    switch (sakStatus) {
        case AktivSakStatus.MOTTATT:
        case AktivSakStatus.INNVILGET:
        case AktivSakStatus.BETALT:
        case AktivSakStatus.SKILT_BESTILT_BRUKER:
        case AktivSakStatus.SKILT_BESTILT:
            return (
                <li className="statusliste__steg">
                    <h3 className="svv-h5">
                        {t('personlig-kjennemerke.status.hent-skilt')}
                    </h3>
                </li>
            );
        case AktivSakStatus.SKILT_MOTTATT:
            return (
                <li className="statusliste__steg aktiv">
                    <h3 className="svv-h5 svv-h5--spacing">
                        {t('personlig-kjennemerke.status.hent-skilt')}
                    </h3>
                    <p>
                        {t('personlig-kjennemerke.status.hent-skilt.ingress')}{' '}
                        <SVVTextLink
                            url="https://ventus.enalog.se/Booking/Booking/Index/VegvesenRislokka"
                            text={t(
                                'personlig-kjennemerke.status.hent-skilt.lenke',
                            )}
                        />
                        .
                    </p>
                </li>
            );
        case DineSkiltSakStatus.SKILT_UTLEVERT:
        case DineSkiltSakStatus.KNYTTET:
            return (
                <li className="statusliste__steg fullfort">
                    <h3 className="svv-h5">
                        {t('personlig-kjennemerke.status.hent-skilt.avhentet')}
                    </h3>
                </li>
            );
        default:
            return <></>;
    }
};
